import React from 'react';
import { Box, Avatar, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { capitalizeFirstLetter } from '../utils/lib';
import PropTypes from 'prop-types';

const ListItemSupplyEdit = ({
  product,       // Nombre del producto (corresponde a txt_product)
  description,   // Detalle del item (ej.: "cant x price" – txt_item_description)
  thumbUrl,      // URL de la imagen, si existe
  avatarContent, // Contenido por defecto para el avatar
  subtotal,      // Subtotal de la fila (txt_subtotal)
  onDelete,       // Función para eliminar la fila
  onMarkSupplied, // Función para marcar como suministrado
  onClick,       // Función para manejar el clic en la fila
  index,
  dateSupply,    // Fecha de suministro (null si no está suministrado)
  dateTentative, // Fecha tentativa de suministro
}) => {
  // Función para obtener el color de fondo basado en el estado del suministro
  const getBackgroundColor = () => {    
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const localDate = dateTentative.includes(' ') ? dateTentative : `${dateTentative} 00:00:00`;
    const tentativeDate = new Date(localDate.replace(' ', 'T'));

    if (dateSupply === null || dateSupply === undefined) {
      // No está suministrado
      if (tentativeDate >= today) {
        // Pendiente
        return '#EBFFB8';
      } else {
        // Vencida
        return '#FFC0BE';
      }
    } else {
      // Está suministrado
      return '#CBFFC1';
    }
  };

  // Se muestra el avatar con la imagen proporcionada o, en su defecto, el contenido por defecto.
  const avatar = thumbUrl ? (
    <Avatar
      alt={capitalizeFirstLetter(product)}
      src={thumbUrl}
      sx={{ width: 30, height: 30 }}
    />
  ) : (
    <Avatar sx={{ width: 30, height: 30 }}>
      {avatarContent}
    </Avatar>
  );

  return (
    <Box
      display="flex"
      alignItems="center"
      width="100%"
      sx={{ 
        padding: '8px',
        backgroundColor: getBackgroundColor(),
        borderRadius: '4px',
        marginBottom: '4px'
      }}
    >
      {/* Imagen o avatar del producto */}
      {avatar}

      {/* Contenedor central para los textos */}
      <Box
        display="flex"
        flexDirection="column"
        flexGrow={1}
        ml={1}  // margen izquierdo (aprox. 8px)
        mr={1}  // margen derecho (aprox. 8px)
        sx={{ cursor: onClick ? 'pointer' : 'default' }}
        onClick={onClick}
      >
        {/* Fila superior: nombre del producto */}
        <Typography
          variant="caption"
          noWrap
          sx={{ marginBottom: '4px' }}
        >
          {product}
        </Typography>

        {/* Fila inferior: descripción (izquierda) y subtotal (derecha) */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="caption">
            {description}
          </Typography>
          <Typography variant="caption" sx={{ marginRight: '8px' }}>
            {subtotal}
          </Typography>
        </Box>
      </Box>

      {/* Botón para marcar como suministrado */}
      {onMarkSupplied && (
        <IconButton 
          onClick={() => onMarkSupplied(index)} 
          sx={{ width: '42px', height: '42px', color: 'success.main' }}
        >
          <CheckIcon />
        </IconButton>
      )}

      {/* Botón para eliminar el item */}
      {onDelete && (
        <IconButton onClick={() => onDelete(index)} sx={{ width: '42px', height: '42px' }}>
          <CloseIcon />
        </IconButton>
      )}
    </Box>
  );
};

ListItemSupplyEdit.propTypes = {
  product: PropTypes.string,
  description: PropTypes.string,
  subtotal: PropTypes.string,
  onDelete: PropTypes.func,
  onMarkSupplied: PropTypes.func,
  onClick: PropTypes.func,
  index: PropTypes.number,
  dateSupply: PropTypes.string, // Fecha de suministro (null si no está suministrado)
  dateTentative: PropTypes.string.isRequired, // Fecha tentativa de suministro
  //... otras props
};

export default ListItemSupplyEdit;